const StickyHeader = () => {
  const stickyHeader = document.querySelector("[data-sticky-header]");
  if (stickyHeader) {
    var stickyHeaderTopOffset = document.createElement("div");
    stickyHeaderTopOffset.setAttribute("data-sticky-header-top-offset", "");
    stickyHeader.parentNode.insertBefore(stickyHeaderTopOffset, stickyHeader);

    const stickyHeaderTopOffsetValue = stickyHeaderTopOffset.offsetTop;
    const stickyClass = "site-header--sticky";

    const updateHeaderState = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      if (scrollY > stickyHeaderTopOffsetValue) {
        stickyHeader.classList.add(stickyClass);
      } else {
        stickyHeader.classList.remove(stickyClass);
      }
    };

    updateHeaderState();

    window.addEventListener("scroll", updateHeaderState);
  }
};

export default StickyHeader;
